import { Observable } from "utils/observables";

export interface IIntegrationService {
  getIntegrationsObservable(): Observable<Integration[]>;
  showConfigurationMenu(integrationId: string): unknown;
  initialize(): void;
  dispose(): void;
}

export type Integration = {
  status: IntegrationStatus;
  id: string;
  name: string;
  icon: string;
};

export enum IntegrationStatus {
  CONNECTED = "CONNECTED",
  NOT_CONFIGURED = "NOT_CONFIGURED",
  DISABLED = "DISABLED",
  DISCONNECTED = "DISCONNECTED",
  WRONG_CONFIGURATION = "WRONG_CONFIGURATION",
  EXPIRED = "EXPIRED",
}
